
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Tracking label='content75' mdxType="Tracking" />
    <p>{`Bleibt die Frage, ob es einen Glauben gibt, der sich trotz rasant zunehmendem
naturwissenschaftlichen Wissen halten kann? Er wäre der grosse Unterschied zum
Aberglauben. Habermas spricht von «nachmetaphysischem Denken», wenn die Moderne
bei der wissenschaftlichen Klärung moralischer Grundfragen den religiösen
Quellen verpflichtet bleibt.`}</p>
    <p>{`Die Synthese von Philosophie und Religion macht die Personalpronomina weltlich:
Das Ich als Individuum mit Anspruch auf Selbstbestimmung, Selbstverwirklichung.
Das Du als sein Gegenüber, Objekt von Achtsamkeit und eigenes Subjekt im Dialog.
Das Er oder Sie als beobachtetes Drittes. Das Wir als kollektive Form des Ich,
ab- und schlimmstenfalls ausgrenzend gegenüber dem Ihr. Und schliesslich das Ihr
als kollektive Form des Du. Darüber stehen für den Frankfurter Philosophen die
Fragen nach den Bedingungen von Erkenntnis und Kommunikation sowie jene nach der
moralischen Lernfähigkeit der Gesellschaft. Erkennen mag in den
Naturwissenschaften durch die Möglichkeit einer zumindest vorläufig gültigen
Beweisbarkeit einfach definiert sein, in den Geistes- und Sozialwissenschaften
ist die Frage seiner Bedingung viel schwieriger zu beantworten. Denn in der
Gesellschaft ist der Beobachter, wenn er sich nicht als manipulativer
Sozialtechniker versteht, stets auch Beteiligter. Das Er und Sie sind immer auch
Ich.`}</p>
    <p>{`Im sozialen Dialog werden die Interessen auf ihre Rechtfertigung geprüft. Der
Dialog ist dann herrschaftsfrei, wenn die Gesprächspartner ihre Ansprüche als
gleichberechtigt anerkennen. Habermas knüpft hier an seine Kommunikationstheorie
an, die er in den 70er-Jahren zusammen mit Karl-Otto Apel entwickelt hat. Der
Mensch unterscheidet sich von anderen Primaten durch seine Sprach- und
allenfalls Vernunftbegabung.`}</p>
    <p>{`Ob die Gesellschaft so nicht nur kog­nitiv, sondern auch moralisch lernfähig
ist, bleibt offen. Habermas ist dabei eher optimistisch, immerhin ist die
Verletzung von Grundrechten wie Nicht-Diskriminierung, physische Integrität,
Würde, Folterverbot als universelle soziale Standards wenigstens seit 70 Jahren
mess- und anklagbar geworden.`}<br /><br />{` In Zeiten stagnierender
Weltorganisationen wie der UNO ist die EU eines der wenigen Laboratorien zur
Suche nach transnationalen Lösungen für ein stabileres Finanzsystem, zu
besteuernde Globalkonzerne, Verhinderung von Monopolen, die Einwanderung.
Habermas spricht sich in diesem Zusammenhang für die Integration von
Migrantinnen und Migranten aus, allerdings nicht über eine starr normierte
Einwanderergesellschaft. Vielmehr fordert er eine neue Gesellschaft mit
gemeinsam ausgehandelten Normen. Unverhandelbar sind dabei die universellen
Grundrechte.`}<br /><br /></p>
    <p>{`Natürlich ist Trost in dieser Welt ohne Abgrenzung und Hokuspokus schwieriger zu
bekommen und vielleicht auch weniger tröstlich als die felsenfeste Zusicherung
ewigen Lebens durch die grossen Religionen. Aber der Mensch ist eben auch das
zweifelnde Tier. Und vielleicht ist die Gewissheit des eigenen Todes für ein
aufgeklärtes Ich sogar besser auszuhalten im Wissen und Glauben an die
gleichberechtigten Ansprüche künftiger Generationen als im Pseudotrost der
Versprechung ewigen Lebens. Allein die Tatsache, dass sich Gentechniker und
dogmatischer Klerus in dieser Vorstellung treffen, sollte misstrauisch machen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;